import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'
import { ResponseCatalog, RequestParams } from 'Models'
import { TemplateModel } from 'Pages/admin/notification'

export type TemplateState = {
	list: ResponseCatalog<TemplateModel>
	requestParams: RequestParams
	isLoading: boolean
	currentTemplate: TemplateModel
}

const initialState: TemplateState = {
	list: new ResponseCatalog<TemplateModel>(),
	requestParams: new RequestParams(),
	isLoading: false,
	currentTemplate: null,
}

export namespace TemplateNS {
	export type SetList = PayloadAction<ResponseCatalog<TemplateModel>>
	export type SetParams = PayloadAction<RequestParams>
	export type GetList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type UpdateOne = PayloadAction<{
		id: number
		data: TemplateModel
		callback?: Callback
		errorCallback?: Callback
	}>
	export type SetIsLoading = PayloadAction<boolean>
	export type GetOne = PayloadAction<{ id: number }>
	export type SetOne = PayloadAction<TemplateModel>
}

export const templateSlice = createSlice({
	name: 'template',
	initialState,
	reducers: {
		setList: (state, action: TemplateNS.SetList) => {
			state.list = action.payload
		},
		setParams: (state, action: TemplateNS.SetParams) => {
			state.requestParams = action.payload
		},
		getList: (state, action: TemplateNS.GetList) => {},
		updateOne: (state, action: TemplateNS.UpdateOne) => {},
		clearAll: (state) => {
			state.requestParams = new RequestParams()
		},
		setIsLoading: (state, action: TemplateNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getOne: (state, action: TemplateNS.GetOne) => {},
		setOne: (state, action: TemplateNS.SetOne) => {
			state.currentTemplate = action.payload
		},
	},
})
